import { type ColorParamsWithHex, colorToHex } from '@bynder-studio/misc';
import type { ColorParams } from '@bynder-studio/render-core';

export const collectCustomColors = (color?: ColorParams): ColorParamsWithHex[] => {
    if (!color || color.brandColorId) {
        return [];
    }

    return [{ ...color, hexCode: colorToHex(color) } as ColorParamsWithHex];
};

export const collectBrandColorIds = (color?: ColorParams): Set<number> => {
    if (color?.brandColorId) {
        return new Set([color.brandColorId]);
    }

    return new Set();
};
